

























































































































































































































import { EventBus, hasElements, TypeEventBus, trackingUnselectedColor, getDiffToNow } from '../../core/utils';
import { JourneysService } from '../../journeys/api/JourneysService';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { phoneValidator } from '../../core/utils/validations';
import { MultipleSelect, MsgBox } from '../../core/components';
import Input from '../../core/components/Input.vue'; 
import InputPhone from '../../core/components/InputPhone.vue'; 
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { Mounted } from '../../core/decorators';
import Axios from 'axios';
import { mask } from 'vue-the-mask';
import { SettingsService } from '../api/SettingsService';
import moment from 'moment';
import { diffOptions } from '../../core/models';

@Component({
    components: { MultipleSelect, MsgBox, Input, InputPhone }
})
export default class ModalConfiguration extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() editing: boolean;
    @Prop() visible: boolean;
    @Prop() driverToEdit: any;
    modalWidth: string = '600';
    optionsToSelect: any = [];
    preselectOptions: any = [];
    driverCompanies: any = [];
    showMultiSelect: boolean = false;
    dialogTagConfirmation: boolean = false;
    showForm: boolean = false;
    driverActive: boolean = false;
    formData: any = {
        name: '',
        ci: null,
        phone_number: null,
        date_of_birth: null,
        tag: null
    };
    formRequest: any = {
        end: null,
        msg: ''
    };
    nameRules: any = [
        v => !!v || 'Debe ingresar nombre y apellido',
        v => (v && v.length >= 7) || 'Debe ingresar nombre y apellido',
        v => /^[a-zA-Z\u00C0-\u017F]/i.test(v) || 'Nombre y apellido inválidos'
    ];

    processingRequest: boolean = false;
    valid: boolean = false;
    menu: boolean = false;
    setMinDate: any = this.getTodayDateLessVal(100);
    setMaxDate: any = this.getTodayDateLessVal(16);
    cancelToken: any = null;
    hoursList: any = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48'
    ];
    hoursRest: any = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24'
    ];
    phoneValidation: any = phoneValidator;

    directives: {
        mask;
    };

    blurInputDocument() {
        if (this.ciValidation(this.formData.ci) == true) {
            if (this.formData.tag == '' || this.formData.tag == null) {
                this.formData.tag = this.formData.ci;
            }
        }
    }

    onEnter() {
        if (this.valid) {
            this.submitDriver();
        }
    }

    get getPreselectedOptions() {
        return this.preselectOptions;
    }

    get getUserCompanies() {
        return this.optionsToSelect;
    }

    disabledSubmit() {
        if (!this.valid || this.processingRequest) {
            return true;
        } else if (this.driverCompanies.length == 0) {
            return true;
        }
    }

    mounted() {
        this.loadModalData();
    }

    updatePhoneNumber(value){
        this.formData.phone_number = value;
    }
    updateDocument(value){
        this.formData.ci = value;
    }
    updateFormDataName(value){
        this.formData.name = value;
    }

    // @Watch('visible')
    loadModalData() {
        if (this.visible) {
            if (this.driverToEdit !== null) {
                this.formData = {
                    name: this.driverToEdit.name,
                    ci: Number(this.driverToEdit.ci),
                    phone_number: this.driverToEdit.phone_number,
                    date_of_birth: this.driverToEdit.date_of_birth,
                    tag: Number(this.driverToEdit.tag)
                };
                this.driverCompanies = this.getCompaniesToEditFromList(this.driverToEdit.company);
                this.resetFormValidation();
            } else {
                this.formData = {
                    name: '',
                    ci: null,
                    phone_number: null,
                    date_of_birth: null,
                    tag: null
                };
                this.driverCompanies = [];
                this.preselectOptions = [];
                this.resetForm();
            }
            this.optionsToSelect = this.$_getCompanies;
            this.showMultiSelect = true;
        } else {
            this.showMultiSelect = false;
            this.driverCompanies = [];
            this.preselectOptions = [];
        }
    }

    get getFormData() {
        return this.formData;
    }

    save(date) {
        let menuElement = this.$refs.menu as HTMLFormElement;
        menuElement.save(date);
    }

    closeDialogTag() {
        this.dialogTagConfirmation = false;
    }

    getCompaniesToEditFromList(companies) {
        let companiesToEdit: any = [];
        let allCompanies = this.$_getCompanies;
        let self = this;
        this.preselectOptions = [];
        for (let i = 0; i < companies.length; i++) {
            for (let b = 0; b < allCompanies.length; b++) {
                if (companies[i].id == allCompanies[b].id) {
                    companiesToEdit.push(allCompanies[b]);
                    self.preselectOptions.push(allCompanies[b]);
                }
            }
        }
        this.preselectOptions = this.removeDuplicatedFromObject(this.preselectOptions);
        return companiesToEdit;
    }

    getTodayDateLessVal(val) {
        let d = new Date();
        let year = d.getFullYear();
        let month = d.getMonth();
        let day = d.getDate();
        let c = new Date(year - val, month, day).toISOString().substr(0, 10);
        return c;
    }

    submitDriver() {
        this.closeDialogTag();
        this.processingRequest = true;
        this.cancelToken = Axios.CancelToken.source();
        let companiesIds = this.getIDFromObject(this.removeDuplicatedFromObject(this.driverCompanies));
        this.formData.name = this.capitalizeFirstsLetterOfString(this.formData.name);
        let payload;
        if (this.editing) {
            payload = this.driverToEdit.id;
            this.formData['companies'] = companiesIds;
            SettingsService.patchDriver(payload, this.formData, false, this.cancelToken)
                .then(response => {
                    this.$_successPatchRecipients('Chofer: ' + this.formData.name + ' modificado con éxito');
                    this.processingRequest = false;
                    this.formData['id'] = this.driverToEdit.id;
                    this.formData['availability'] = this.driverToEdit.availability;
                    this.closeDialog(true, this.formData);
                })
                .catch(error => {
                    let hasError = error.response.data.message ? error.response.data.message : null;
                    this.$_catchLoadingDialog({
                        response: error.response.data || {},
                        alternative_msg: 'No se pudo modificar el chofer'
                    });
                    this.processingRequest = false;
                    if (hasError == null) {
                        this.closeDialog(false, null);
                    }
                });
        } else {
            payload = companiesIds;

            SettingsService.postDriver(payload, this.formData, false, this.cancelToken)
                .then(response => {
                    this.$_successPatchRecipients('Chofer ' + response.name + ' creado con éxito');
                    this.processingRequest = false;
                    this.closeDialog(true, response);
                })
                .catch(error => {
                    let hasError = error.response.data.message ? error.response.data.message : null;
                    
                    this.processingRequest = false;

                    this.$_catchLoadingDialog({
                         response: error.response.data || {},
                         alternative_msg: 'No se pudo crear el chofer'
                    })

                    if (hasError == null) {
                        this.closeDialog(false, null);
                    }
                });
        }
    }

    capitalizeFirstsLetterOfString(string) {
        return string.toLowerCase().replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
    }

    addResultMesage(end, msg) {
        this.formRequest = {
            end: end,
            msg: msg
        };
    }

    getIDFromObject(object) {
        let ids: any = [];
        for (let i = 0; i < object.length; i++) {
            ids.push(object[i].id);
        }
        return ids.join(',');
    }

    removeDuplicatedFromObject(object) {
        let uniqueObject = object.filter(function(item, pos) {
            return object.indexOf(item) == pos;
        });

        return uniqueObject;
    }

    get form(): Vue & { validate: () => boolean } {
        return this.$refs.form_driver as Vue & { validate: () => boolean };
    }

    @Watch('driverCompanies')
    companiesChange(val) {
        this.forceValidation();
    }

    handleSelected(itemToAdd) {
        this.driverCompanies.push(itemToAdd);
    }

    handleRemoveOption(itemToRemove) {
        this.driverCompanies = this.driverCompanies.filter(item => item.id !== itemToRemove.id);
    }

    @Watch('menu')
    watchMenu(val) {
        val && setTimeout(() => ((this.$refs.picker as HTMLFormElement).activePicker = 'YEAR'));
    }

    checkDate(date) {
        if (date.length !== 10) {
            return false;
        } else {
            let years = getDiffToNow(date, diffOptions.years);
            if (years > 100 || years < 0) {
                return false;
            } else {
                return true;
            }
        }
    }

    datePickerValidation(val) {
        if (val == null || val == undefined) {
            return 'Debe asignar una fecha de nacimiento';
        } else if (!this.checkDate(val)) {
            return 'Fecha inválida';
        } else if (val.length > 10) {
            return 'Fecha inválida';
        } else {
            return true;
        }
    }

    ciValidation(val) {
        return this.validateDocAndTag(val);
    }

    //  stringIsOnlyLetters(word){
    //     var onlyLetters = /^[a-zA-Z\u00C0-\u00ff]+$/;
    //     return onlyLetters.test(word)
    //   }

    //   dniValidation(dni){
    //     var expresion_regular_dni = /(^([0-9]{8,8}\-[A-Z])|^)$/;

    //     if(expresion_regular_dni.test (dni)){
    //       return true
    //     }else{
    //       return false
    //     }
    //   }

    tagValidation(val) {
        return this.validateDocAndTag(val);
    }

    validateDocAndTag(value) {
        if (value == null || value.length == 0) {
            return 'Este campo es obligatorio';
        } else if (value.length < 8) {
            return 'Debe tener mínimo 8 caracteres';
        } else if (value.length > 12) {
            return 'Debe tener máximo 12 caracteres';
        } else {
            return true;
        }
    }

    submit() {
        if (this.form.validate()) {
            if (!this.editing && this.formData.tag !== this.formData.ci) {
                this.dialogTagConfirmation = true;
            } else {
                this.submitDriver();
            }
        }
    }

    forceValidation() {
        let formElement = this.$refs.form_driver as HTMLFormElement;
        this.$nextTick(() => {
            if (formElement !== undefined) {
                formElement.validate();
            }
        });
    }

    resetFormValidation() {
        let formElement = this.$refs.form_driver as HTMLFormElement;
        this.$nextTick(() => {
            if (formElement) {
                formElement.resetValidation();

                formElement.validate();
            }
        });
    }

    resetForm() {
        this.processingRequest = false;
        let formElement = this.$refs.form_driver as HTMLFormElement;
        this.$nextTick(() => {
            if (formElement) {
                formElement.reset();
                formElement.resetValidation();
            }
        });
        this.formRequest = {
            end: null,
            msg: ''
        };
    }

    getMinutesFromHoursAndMinutes(hours, minutes) {
        return parseInt(hours) * 60 + parseInt(minutes);
    }

    getHoursAndMinutesFromMinutes(mins) {
        let hours = Math.floor(mins / 60);
        let minutes = mins % 60;
        return {
            hours: hours.toString(),
            minutes: minutes.toString()
        };
    }

    @Emit()
    closeDialog(action: boolean, driver: any) {}
}
